import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import CustomTextareaComponent from "components/Form/CustomTextareaComponent";
import Select from "components/Form/Select";

const schemaValidation = Yup.object().shape({
	comment: Yup.string(),
});

const CommentNurseHelpModal = ({ open, close, abort, submit, folder, addComment, cancel, cancelResaonsOptions, incompleteFolder }) => {
	return (
		<Modal size="small" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
			<Modal.Header>
				Télésecrétariat - {incompleteFolder && "Dossier incomplet - Envoyer un email au patient ou à la patiente"}
				{!incompleteFolder && (
					<>
						{!abort
							? !addComment
								? "Vous avez apporté votre aide sur ce dossier"
								: "Ajouter un commentaire"
							: !cancel
							? "Vous êtes sur le point d'annuler votre prise en charge du dossier"
							: "Etes-vous sûr de vouloir annuler cette demande ? "}
					</>
				)}
			</Modal.Header>
			<Formik
				enableReinitialize
				initialValues={{
					folderId: folder.id,
					comment: "",
				}}
				validationSchema={schemaValidation}
				onSubmit={(values) => {
					if (abort && !values.reason) return;
					if (addComment) addComment(folder.folderHelp.id, values.comment);
					else submit(abort, values.reason, values.comment, incompleteFolder);
					close();
				}}
			>
				{({ submitForm }) => (
					<>
						<Modal.Content>
							<Form>
								{abort && (
									<Field
										component={Select}
										name="reason"
										customlabel="Veuillez saisir la raison de l'annulation."
										placeholder="Raison d'annulation"
										options={cancelResaonsOptions
											.filter((c) =>
												incompleteFolder ? c.group === "EMAILPATIENT" : !cancel ? c.group === "BYSECRETARY" : c.group === "BYSEC_FOLDER"
											)
											.map((option) => {
												return {
													value: option.id,
													label: option.label,
												};
											})}
										required={true}
									/>
								)}
								<Field autoFocus component={CustomTextareaComponent} name="comment" customlabel="Commentaire" />
							</Form>
						</Modal.Content>

						<Modal.Actions>
							<Button
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									close();
								}}
							>
								Annuler
							</Button>
							<Button
								primary
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									submitForm();
								}}
							>
								Confirmer
							</Button>
						</Modal.Actions>
					</>
				)}
			</Formik>
		</Modal>
	);
};

export default CommentNurseHelpModal;
